import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-213900ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = { class: "footer-content" }
const _hoisted_3 = { class: "agreement" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "copyright" }, [
  /*#__PURE__*/_createTextVNode(" Copyright⑥2021-2022欣欣相融教育科技(深圳) 有限公司粤ICP备18040912号-8"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 【深圳市福田区华强北街道福强社区红荔路2001号四川大厦1层1号104-2】 联系方式：010-52926669转8669 ")
], -1))

import {onMounted, ref} from 'vue'
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'footerComponent',
  setup(__props) {

const url = ref(window.location.origin + window.location.pathname)

const router = useRouter()
const route = useRoute()
onMounted(() => {
    url.value = url.value.substring(0, url.value.length - 1)
    
})
const goagreement = (type: number) => {
    const routeUrl = router.resolve({
        path: '/agreement',
        query: {
            type
        }
    })
    window.open(routeUrl.href, '_blank')
    
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", {
          class: "xieyi",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goagreement(1)))
        }, "用户协议"),
        _createElementVNode("span", {
          class: "yinsi",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goagreement(2)))
        }, "隐私保护")
      ]),
      _hoisted_4
    ])
  ]))
}
}

})